export function dig(object, ...path) {
  return path.reduce(
    (nested, part) => (nested ? nested[part] || "" : ""),
    object
  );
}

export function has(object, method) {
  return object && Object.prototype.hasOwnProperty.call(object, method);
}

export const tableFilter = (row, filters) =>
  Object.entries(filters).every(([col, value]) => {
    const term = value ? value.toString().toLowerCase() : "";
    const path = col.split(".");
    const cell = dig(row, ...path);

    return cell.toString().toLowerCase().includes(term);
  });

export function deepSortObjectByKeys(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepSortObjectByKeys(item));
  }

  return Object.fromEntries(
    Object.entries(obj)
      .sort(([first], [second]) => first.localeCompare(second))
      .map(([key, value]) => [key, deepSortObjectByKeys(value)])
  );
}
